import React, { useState, useEffect, useRef } from "react";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import { data, useNavigate } from "react-router-dom";
import Combobox from "../../components/Combobox";
import QRCodeGenerator from '../../components/QRCodeGenerator.jsx';
import jsQR from "jsqr";
import Loader from '../../components/Loader.jsx';
import Table from "../../components/Table";
import PopUp from "../../components/PopUp";
import Checkbox from "../../components/Checkbox";
import Input from "../../components/Input";
import DatePicker from "../../components/DatePicker";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { useDeviceLayout } from "../../components/DeviceLayoutProvider";
import { Printer, Images, QrCode, Download, Upload, ScanLine, Trash2, SquarePen, RotateCcw } from "lucide-react";

let stati = [];

const RowPC = ({ data, onCheckboxChange, setAlertInfo, setShowAlert, impianti }) => {
    const [isFotoVisible, setIsFotoVisible] = useState(false);
    const [isImgVisible, setIsImgVisible] = useState(false);
    const [img, setImg] = useState("");
    const [dataFoto, setDataFoto] = useState({});
    const [viewData, setViewData] = useState([]);
    const [filter, setFilter] = useState("");

    useEffect(() => {
        if (isFotoVisible) {
            const getFoto = async () => {
                try {
                    const r = await fetch('/getFotos', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente.CodiceDominio,
                            IDComponente: data.value.ID
                        }),
                    });

                    const rd = await r.json();

                    if (r.status !== 200) {
                        console.error(rd.error);
                        setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                        setShowAlert(true);
                        setDataFoto([]);
                        setIsFotoVisible(false);
                    }
                    else {
                        setDataFoto(rd);
                    }
                } catch (error) {
                    console.error("Errore nel caricamento delle foto:", error);
                    setAlertInfo({ type: "error", text: "Errore nel caricamento delle foto. Riprova più tardi.", onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    setDataFoto([]);
                    setIsFotoVisible(false);
                }
            };

            getFoto();
        }
    }, [isFotoVisible]);

    useEffect(() => {
        setViewData(
            filter === ""
                ? dataFoto
                : dataFoto.filter((x) => {
                    const searchTerm = filter.toLowerCase();
                    return (
                        x["PathFoto"].split("/").pop().toLowerCase().includes(searchTerm) ||
                        x["Descrizione"].toLowerCase().includes(searchTerm) ||
                        x["Timestamp"].toLowerCase().includes(searchTerm) ||
                        x["NomeUtente"].toLowerCase().includes(searchTerm) ||
                        x["CognomeUtente"].toLowerCase().includes(searchTerm)
                    );
                })
        );
    }, [filter, dataFoto]);

    const handleFotoClick = async (path) => {
        try {
            const r = await fetch('/getImage', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    PathFoto: path,
                })
            });

            if (r.status !== 200) {
                const rd = await r.json();
                console.error(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
            else {
                const blob = await r.blob();
                const url = URL.createObjectURL(blob);
                setImg(url);
                setIsImgVisible(true);
            }
        }
        catch (error) {
            console.error("Errore nel caricamento dell'immagine:", error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dell'immagine. Riprova più tardi.", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    return (
        <div className="flex flex-row">
            <div onClick={(e) => e.stopPropagation()} className="flex items-center justify-center">
                <Checkbox
                    checked={data.checked}
                    onChange={() => onCheckboxChange(data.value.ID)}
                    size={18}
                />
            </div>
            <div className="grid grid-cols-8 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Codice}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Descrizione}
                </div>
                <div className="flex items-center pl-2 ">
                    {impianti.find(i => i.ID === data.value.IDImpianto)?.Nome + (impianti.find(i => i.ID === data.value.IDImpianto)?.Descrizione ? ` - ${impianti.find(i => i.ID === data.value.IDImpianto)?.Descrizione}` : "") || ''}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Categoria}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.DataInstallazione}
                </div>
                <div className="flex items-center pl-2" style={{ color: stati.find(s => s.Nome === data.value.StatoAttuale)?.Colore || 'inherit' }}>
                    {data.value.StatoAttuale}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.ProssimaManutenzione}
                </div>
                <div className="flex items-center pl-2 ">
                    <Button type="icon" onClick={(e) => { e.stopPropagation(); setIsFotoVisible(true); }}>
                        <Images size={20} strokeWidth={2} className="inline-block cursor-pointer text-blue-600" />
                    </Button>
                </div>
            </div>
            <PopUp title={"Foto"}
                isVisible={isFotoVisible}
                setIsVisible={setIsFotoVisible}
                needConfirm={false}
            >
                <div className="flex flex-col items-center">
                    <div className="w-[80%]">
                        <Input
                            label="Filtra foto..."
                            value={filter}
                            setValue={setFilter}
                            type="text"
                            classes="mb-2 w-full"
                            disabled={false}
                            error={false}
                        />
                        {
                            viewData.length > 0 ? (
                                viewData.map((elem, index) => (
                                    <>
                                        <div
                                            className="grid grid-cols-2 p-2 rounded bg-gray-200 dark:bg-neutral-800 hover:bg-gray-300 dark:hover:bg-neutral-700 hover:cursor-pointer my-2"
                                            onClick={() => handleFotoClick(elem["PathFoto"])}
                                        >
                                            <span className="self-center font-bold">{elem["PathFoto"].split("/").pop()}</span>
                                            <span className="self-center text-right">{elem["Timestamp"]}</span>
                                            <span className="self-center">{elem["Descrizione"]}</span>
                                            <span className="self-center text-right italic">{`${elem["CognomeUtente"]} ${elem["NomeUtente"]}`}</span>
                                        </div>
                                        {
                                            isImgVisible && img && (
                                                <div
                                                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back"
                                                    onClick={() => setIsImgVisible(false)}
                                                >
                                                    <div className="p-4 rounded-lg" style={{ maxWidth: "90vw", maxHeight: "90vh" }}>
                                                        <img
                                                            src={img}
                                                            alt="Preview"
                                                            className="max-w-full max-h-[80vh] mx-auto block rounded-md"
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </>
                                ))
                            ) : (
                                <p className="text-center">Nessuna foto trovata.</p>
                            )
                        }
                    </div>
                </div>
            </PopUp>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview, impianti }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && header.label !== "Foto" && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm" style={header.key === "StatoAttuale" ? { color: stati.find(s => s.Nome === data.value[header.key])?.Colore || 'inherit' } : {}}>
                                {header.key === "IDImpianto" ? impianti.find(i => i.ID === data.value[header.key])?.Nome + (impianti.find(i => i.ID === data.value[header.key])?.Descrizione ? ` - ${impianti.find(i => i.ID === data.value[header.key])?.Descrizione}` : "") : data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
};

const Anagrafica = () => {
    const { isLittle } = useDeviceLayout();
    const headers = [
        { label: 'Nome', key: 'Codice' },
        { label: 'Descrizione', key: 'Descrizione' },
        { label: 'Sito', key: 'IDImpianto' },
        { label: 'Categoria', key: 'Categoria' },
        { label: 'Data Installazione', key: 'DataInstallazione' },
        { label: 'Stato Attuale', key: 'StatoAttuale' },
        { label: 'Prossima Manutenzione', key: 'ProssimaManutenzione' },
        { label: 'Foto', key: '' }
    ];
    const [dataTable, setDataTable] = useState([]);
    const [dataRow, setDataRow] = useState({});
    const [dataAdd, setDataAdd] = useState({
        "ID": null,
        "Codice": null,
        "Descrizione": null,
        "IDImpianto": null,
        "IDCategoria": null,
        "DataInstallazione": null
    });
    const [isRowInfoVisible, setIsRowInfoVisible] = useState(false);
    const [isAddVisible, setIsAddVisible] = useState(false);
    const [isQrCodeVisible, setIsQrCodeVisible] = useState(false);
    const [needConfirmRow, setNeedConfirmRow] = useState(false);
    const [isPopUpFotoVisible, setIsPopUpFotoVisible] = useState(false);
    const [isSezioneNascostaVisible, setIsSezioneNascostaVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectAziende, setSelectAziende] = useState([]);
    const [idCliente, setIdCliente] = useState("");
    const [selectMacroCat, setSelectMacroCat] = useState([]);
    const [selectedMacroCat, setSelectedMacroCat] = useState(null);
    const [selectSottoCat, setSelectSottoCat] = useState([]);
    const [scanning, setScanning] = useState(false);
    const [qrCodeContent, setQRCodeContent] = useState(null);
    const navigate = useNavigate();
    const canvasRef = useRef(null);
    const [isImgVisible, setIsImgVisible] = useState(false);
    const [img, setImg] = useState("");
    const [dataFoto, setDataFoto] = useState({});
    const [viewData, setViewData] = useState([]);
    const [filter, setFilter] = useState("");
    const [isReassign, setIsReassign] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });
    const [impianti, setImpianti] = useState([]);

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        if (isPopUpFotoVisible) {
            const getFoto = async () => {
                try {
                    const r1 = await fetch('/getFotos', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente.CodiceDominio,
                            IDComponente: dataRow.value.ID
                        }),
                    });

                    const rd1 = await r1.json();

                    if (r1.status !== 200) {
                        console.error(rd1.error);
                        setAlertInfo({ type: "error", text: rd1.error, onClose: () => setShowAlert(false), needConfirm: false });
                        setShowAlert(true);
                        setDataFoto([]);
                        setIsPopUpFotoVisible(false);
                    } else {
                        setDataFoto(rd1);
                    }
                } catch (error) {
                    console.error("Errore nel caricamento delle foto:", error);
                    setAlertInfo({ type: "error", text: "Errore nel caricamento delle foto. Riprova più tardi.", onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    setDataFoto([]);
                    setIsPopUpFotoVisible(false);
                }
            };

            getFoto();
        }
    }, [isPopUpFotoVisible]);

    useEffect(() => {
        setViewData(
            filter === ""
                ? dataFoto
                : dataFoto.filter((x) => {
                    const searchTerm = filter.toLowerCase();
                    return (
                        x["PathFoto"].split("/").pop().toLowerCase().includes(searchTerm) ||
                        x["Descrizione"].toLowerCase().includes(searchTerm) ||
                        x["Timestamp"].toLowerCase().includes(searchTerm) ||
                        x["NomeUtente"].toLowerCase().includes(searchTerm) ||
                        x["CognomeUtente"].toLowerCase().includes(searchTerm)
                    );
                })
        );
    }, [filter, dataFoto]);

    const onload = async () => {
        //getInfoUtente
        setIsLoading(true);
        try {
            await loadNav();

            //loadSelectAziende
            const r2 = await fetch('/getAziende', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"]
                })
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                console.error(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { navigate("/manager/dash"); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setSelectAziende(rd2.filter((d) => d["Obsoleta"] === false));

                //loadSelectTipologia
                const r3 = await fetch('/getCategorie', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"]
                    })
                });
                const rd3 = await r3.json();

                if (r3.status === 500) {
                    console.error(rd3.error);
                    setAlertInfo({ type: "error", text: rd3.error, onClose: () => { navigate("/manager/dash"); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setSelectMacroCat(rd3.filter((d) => d["Obsoleta"] === false && d["IDPadre"] === null));
                    setSelectSottoCat(rd3.filter((d) => d["Obsoleta"] === false && d["IDPadre"] !== null));

                    const r4 = await fetch('/getStati', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"]
                        })
                    });
                    const rd4 = await r4.json();
                    if (r4.status === 500) {
                        console.error(rd4.error);
                        setAlertInfo({ type: "error", text: rd4.error, onClose: () => { navigate("/manager/dash"); }, needConfirm: false });
                        setShowAlert(true);
                    } else {
                        stati = rd4;

                        //scelgo il preselezionato
                        if (document.cookie.indexOf("PreselectAzienda") !== -1) {
                            const preselect = document.cookie.split("PreselectAzienda=")[1].split(";")[0];
                            if (preselect !== '') {
                                handleChange(Number(preselect));
                            } else {
                                setIsSezioneNascostaVisible(false);
                            }
                        }
                    }
                }

            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprova più tardi", onClose: () => { navigate("/manager/dash"); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleChange = async (text) => {
        if (text === idCliente) return;
        setIsSezioneNascostaVisible(false);

        setIdCliente(text);

        if (text === null) {
            document.cookie = `PreselectAzienda=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            setIsSezioneNascostaVisible(false);
        }
        else {
            document.cookie = `PreselectAzienda=${text}; path=/;`;
            setIsLoading(true);
            try {
                const r = await fetch("/getComponenti", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        IDAzienda: text
                    })
                });
                const rd = await r.json();
                if (r.status === 500) {
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { window.location.reload() }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setDataTable(rd.map((d) => ({ value: d, checked: false })));
                    setIsSezioneNascostaVisible(true);
                }

                const r2 = await fetch("/getImpiantiByAzienda", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        IDAzienda: text
                    })
                });
                const rd2 = await r2.json();
                if (r2.status === 500) {
                    console.log(rd2.error);
                    setAlertInfo({ type: "error", text: rd2.error, onClose: () => { window.location.reload() }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setImpianti(rd2.filter(i => i.Obsoleto === false));
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento dei dati, riprova più tardi", onClose: () => { navigate("/manager/dash"); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        }
    };

    const handleStampa = async () => {
        const selectedElements = dataTable.filter((d) => d.checked).map((d) => d.value["ID"]);
        if (selectedElements.length === 0) {
            setAlertInfo({ type: "info", text: "Selezionare almeno un elemento", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        // Genera tutti i QR code prima di aprire la finestra
        const qrCodes = [];
        for (const codice of selectedElements) {
            try {
                const qrUrl = await generaQrCode(codice);
                qrCodes.push({ codice, qrUrl });
            } catch (error) {
                console.error(`Errore nella generazione del QR code per ${codice}:`, error);
                qrCodes.push({ codice, qrUrl: null });
            }
        }

        // Crea la finestra di stampa
        const printWindow = window.open("", "_blank", "width=900,height=700");

        // CSS per il layout con 4 per riga
        const css = `
            <style>
                @media print {
                    @page {
                        margin: 0.5cm;
                        size: A4 portrait;
                    }
                    
                    body {
                        margin: 0;
                        padding: 0;
                        font-family: Arial, sans-serif;
                    }
                    
                    .qr-container {
                        page-break-inside: avoid;
                    }
                    
                    .qr-row {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                    
                    .qr-item {
                        page-break-inside: avoid;
                    }
                }
                
                body {
                    margin: 0;
                    padding: 15px;
                    font-family: Arial, sans-serif;
                    max-width: 210mm; /* Larghezza A4 */
                    margin: 0 auto;
                }
                
                .qr-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr); /* 4 colonne per riga */
                    gap: 15px;
                    width: 100%;
                }
                
                .qr-item {
                    border: 3px solid #000;
                    border-radius: 15px;
                    padding-top: 12px;
                    padding-bottom: 12px;
                    padding-left: 6px;
                    padding-right: 6px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 200px;
                    box-sizing: border-box;
                    background-color: white;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    break-inside: avoid;
                }
                
                .qr-image-container {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    min-height: 120px;
                    margin-bottom: 8px;
                }
                
                .qr-image {
                    max-width: 100%;
                    max-height: 120px;
                    width: auto;
                    height: auto;
                    display: block;
                }
                
                .qr-code-text {
                    font-size: 12px;
                    font-weight: bold;
                    text-align: center;
                    word-break: break-all;
                    background-color: #f5f5f5;
                    border-radius: 5px;
                    width: 100%;
                    box-sizing: border-box;
                    margin-top: auto;
                    border: 1px solid #ddd;
                    font-family: 'Courier New', monospace;
                }
                
                .no-qr {
                    color: #ff0000;
                    font-size: 11px;
                    text-align: center;
                    font-weight: bold;
                    padding: 10px;
                }
                
                /* Per gestire meglio la stampa su più pagine */
                @media print {
                    .qr-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 12px;
                    }
                    
                    .qr-item {
                        min-height: 180px;
                        border: 2px solid #000;
                    }
                    
                    .qr-code-text {
                        font-size: 10px;
                        padding: 4px;
                    }
                }
                
                /* Responsive per schermi piccoli */
                @media screen and (max-width: 1000px) {
                    .qr-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 10px;
                    }
                }
            </style>
        `;

        // Dividi i QR codes in gruppi se necessario per la stampa
        const qrItems = qrCodes.map((item) => {
            return `
                <div class="qr-item">
                    <div class="qr-image-container">
                        ${item.qrUrl
                    ? `<img src="${item.qrUrl}" alt="QR Code per ${item.codice}" class="qr-image" />`
                    : `<div class="no-qr">QR non disponibile</div>`
                }
                    </div>
                    <div class="qr-code-text">${item.codice}</div>
                </div>
            `;
        }).join('');

        printWindow.document.write(`
            <html>
                <head>
                    <title>Stampa QR Code - ${qrCodes.length} elementi</title>
                    ${css}
                </head>
                <body>
                    <div class="qr-grid">
                        ${qrItems}
                    </div>
                    <script>
                        // Attendi il caricamento di tutte le immagini
                        let images = document.getElementsByTagName('img');
                        let imagesLoaded = 0;
                        const totalImages = images.length;
                        
                        function checkAllImagesLoaded() {
                            imagesLoaded++;
                            if (imagesLoaded === totalImages) {
                                printAfterDelay();
                            }
                        }
                        
                        function printAfterDelay() {
                            setTimeout(() => {
                                window.print();
                                // Chiudi la finestra dopo la stampa
                                window.onafterprint = function() {
                                    window.close();
                                };
                            }, 500);
                        }
                        
                        // Se non ci sono immagini, stampa subito
                        if (totalImages === 0) {
                            printAfterDelay();
                        } else {
                            // Controlla il caricamento di ogni immagine
                            for (let i = 0; i < images.length; i++) {
                                if (images[i].complete) {
                                    checkAllImagesLoaded();
                                } else {
                                    images[i].onload = checkAllImagesLoaded;
                                    images[i].onerror = checkAllImagesLoaded;
                                }
                            }
                        }
                    </script>
                </body>
            </html>
        `);

        printWindow.document.close();
    };

    const generaQrCode = async (id) => {
        return await QRCodeGenerator.generateQRCode(id);
    };

    const handleElimina = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch("/eliminaComponente", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        ID: dataRow.value["ID"]
                    })
                });

                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { window.location.reload(); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    window.location.reload();
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore durante l'eliminazione del componente, riprova più tardi", onClose: () => { window.location.reload(); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare l'articolo?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmPopUpModifica = async () => {
        if (!dataRow.value["IDCategoria"] || !dataRow.value["DataInstallazione"] || !dataRow.value["ID"] || !dataRow.value["IDImpianto"]) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        try {
            const r1 = await fetch("/aggiornaComponente", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    ID: dataRow.value["ID"],
                    Codice: dataRow.value["Codice"] || "",
                    IDCategoria: dataRow.value["IDCategoria"],
                    DataInstallazione: dataRow.value["DataInstallazione"],
                    Descrizione: dataRow.value["Descrizione"] || "",
                    IDAzienda: Number(dataRow.CodiceCliente) || Number(idCliente),
                    IDImpianto: dataRow.value["IDImpianto"]
                }),
            });
            if (r1.status === 500) {
                const rd1 = await r1.json();
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { window.location.reload(); }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante la modifica del componente, riprova più tardi", onClose: () => { window.location.reload(); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleQrCode = async () => {
        if (dataAdd["ID"]) {
            setAlertInfo({ type: "info", text: "Il codice QR è già stato inserito", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsQrCodeVisible(true);
    };

    const handleScanCode = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: { ideal: 'environment' }
                }
            });
            const video = document.querySelector('video#scan');
            video.srcObject = stream;
            video.removeAttribute('hidden');
            setScanning(true);
            setQRCodeContent(null);

            requestAnimationFrame(detectQRCode);
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'accesso alla fotocamera. Assicurati di aver concesso tutti i permessi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
    };

    const detectQRCode = async () => {
        const video = document.querySelector('video#scan');
        const canvas = canvasRef.current;
        try {
            const ctx = canvas.getContext('2d');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            try {
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);
                if (code) {
                    const tracks = video.srcObject?.getTracks();
                    tracks?.forEach(track => track.stop());
                    setScanning(false);
                    confirmPopUpQrCode({ codice: code.data });
                } else {
                    requestAnimationFrame(detectQRCode);
                }
            } catch (error) {
                requestAnimationFrame(detectQRCode);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleStopScan = () => {
        const video = document.querySelector('video#scan');
        const stream = video.srcObject;
        const tracks = stream?.getTracks();

        tracks?.forEach(function (track) {
            track.stop();
        });

    };

    const confirmPopUpAdd = async () => {
        if (!dataAdd.IDCategoria || !dataAdd.DataInstallazione || !dataAdd.ID || !dataAdd.IDImpianto) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        try {
            const r1 = await fetch("/addComponente", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    ID: dataAdd["ID"] || null,
                    IDAzienda: idCliente,
                    Codice: dataAdd["Codice"] || "",
                    IDCategoria: dataAdd["IDCategoria"],
                    DataInstallazione: dataAdd["DataInstallazione"],
                    Descrizione: dataAdd["Descrizione"] || "",
                    IDImpianto: dataAdd["IDImpianto"]
                }),
            });
            if (r1.status === 500) {
                const rd1 = await r1.json();
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { window.location.reload(); }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore durante l'aggiunta del componente, riprova più tardi", onClose: () => { window.location.reload() }, needConfirm: false });
            setShowAlert(true);
            console.log(error);
        }
        setIsLoading(false);
    };

    const confirmPopUpQrCode = async ({ codice = null }) => {
        if (!codice && qrCodeContent === '') {
            setAlertInfo({ type: "warning", text: "Inserire un codice QR valido", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            if (isReassign) {
                const r = await fetch("/checkCodiceQr", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceQr: codice || qrCodeContent,
                    })
                });

                if (r.status === 500 || r.status === 401) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                } else if (r.status === 200) {
                    const pass = async () => {
                        const r2 = await fetch('/aggiornaIDComponente', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente.CodiceDominio,
                                ID: dataRow.value.ID,
                                NuovoID: codice || qrCodeContent
                            })
                        });
                        if (r2.status === 500) {
                            const rd2 = await r2.json();
                            console.log(rd2.error);
                            setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                            setShowAlert(true);
                        }
                        else {
                            setIsReassign(false);
                            setAlertInfo({ type: "success", text: "Riassegnazione avvenuta con successo", onClose: () => { window.location.reload() }, needConfirm: false });
                            setShowAlert(true);
                        }
                    };
                    setAlertInfo({ type: "warning", text: "Sei sicuro di voler riassegnare il codice QR? Questa è un'operazione irreversibile", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
                    setShowAlert(true);
                }
            }
            else {
                const r = await fetch("/checkCodiceQr", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceQr: codice || qrCodeContent,
                    })
                });

                if (r.status === 500 || r.status === 401) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                } else if (r.status === 200) {
                    setDataAdd({ ...dataAdd, ID: codice || qrCodeContent });
                    setIsQrCodeVisible(false);
                }
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante la verifica del codice QR, riprova più tardi", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleImport = () => {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = ".csv";
        fileInput.click();
        fileInput.onchange = (event) => {
            const file = event.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = function (event) {
                const text = event.target.result;
                const rows = text.split("\n").map(row => row.split(",").map(cell => cell.replace(/"/g, "")));
                if (rows.length < 2) {
                    setAlertInfo({ type: "error", text: "File CSV non valido", onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                    return;
                }
                rows.shift();
                const data = rows[0][0].split(";");
                const isCategoriaValida = selectSottoCat.some(cat => cat.Nome.toLowerCase() === data[4].toLowerCase() && cat.Descrizione.toLowerCase() === data[5].toLowerCase());
                if (data.length !== 7 || !isCategoriaValida) {
                    setAlertInfo({ type: "error", text: "Le informazioni della categoria sono errate. Inserire i valori così come stati inseriti in fase di creazione della categoria", onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                    return;
                }
                const isImpiantoValido = impianti.some(imp => imp.Nome.toLowerCase() === data[2].toLowerCase() && imp.Descrizione.toLowerCase() === data[3].toLowerCase());
                if (!isImpiantoValido) {
                    setAlertInfo({ type: "error", text: "Le informazioni dell'impianto sono errate. Inserire i valori così come stati inseriti in fase di creazione dell'impianto", onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                    return;
                }
                setDataAdd({
                    Codice: data[0],
                    Descrizione: data[1],
                    IDImpianto: impianti.find(imp => imp.Nome === data[2] && imp.Descrizione === data[3])?.ID || null,
                    IDCategoria: selectSottoCat.find(cat => cat.Nome === data[4] && cat.Descrizione === data[5])?.ID || null,
                    DataInstallazione: data[6],
                });
                setAlertInfo({ type: "success", text: "Importazione avvenuta con successo. Completa i campi mancanti e salva.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            };
            reader.onerror = function () {
                console.error("Errore durante la lettura del file CSV");
                setAlertInfo({ type: "error", text: "Errore durante la lettura del file CSV", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            };

            reader.readAsText(file);
        }
    };

    const handleExport = () => {
        if (!dataRow.value.IDCategoria || !dataRow.value.DataInstallazione || !dataRow.value.IDImpianto) {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        const data = [
            ["Codice", "Descrizione", "Nome Impianto", "Descrizione Impianto", "Nome Categoria", "Descrizione Categoria", "Data Installazione"],
            [dataRow.value.Codice, dataRow.value.Descrizione, impianti.find(imp => imp.ID === dataRow.value.IDImpianto)?.Nome || "", impianti.find(imp => imp.ID === dataRow.value.IDImpianto)?.Descrizione || "", selectSottoCat.find(cat => cat.ID === dataRow.value.IDCategoria)?.Nome || "", selectSottoCat.find(cat => cat.ID === dataRow.value.IDCategoria)?.Descrizione || "", dataRow.value.DataInstallazione]
        ];
        const filename = "Export_Articolo.csv";

        // Crea il contenuto del CSV
        const csvContent = data
            .map(row => row.map(cell => `"${cell}"`).join(";"))
            .join("\n"); // Unisci le righe con newline

        // Crea un blob con il contenuto CSV
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        // Crea un link per scaricare il file
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", filename);

        // Aggiungi e clicca il link per forzare il download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleFotoClick = async (path) => {
        try {
            const r = await fetch('/getImage', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    PathFoto: path,
                })
            });

            if (r.status !== 200) {
                const rd = await r.json();
                console.error(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                const blob = await r.blob();
                const url = URL.createObjectURL(blob);
                setImg(url);
                setIsImgVisible(true);
            }
        }
        catch (error) {
            console.error("Errore nel caricamento dell'immagine:", error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dell'immagine. Riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"ANAGRAFICA ARTICOLI"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <div className="flex items-center justify-center w-full">
                    <Combobox
                        options={selectAziende.map((item) => ({
                            label: item["Nome"],
                            value: item["ID"]
                        }))}
                        onChange={(value) => { handleChange(value) }}
                        label="Cliente"
                        classes="w-[80%] md:w-[40%] mt-4"
                        disabled={false}
                        readOnly={false}
                        defaultValue={Number(idCliente)}
                    />
                </div>
                {
                    isSezioneNascostaVisible && (
                        <>
                            <Table
                                headers={headers}
                                keyForPreview={["Codice", "Descrizione", "ProssimaManutenzione"]}
                                data={dataTable}
                                setData={setDataTable}
                                renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} onCheckboxChange={handleRowCheckboxChange} setAlertInfo={setAlertInfo} setShowAlert={setShowAlert} impianti={impianti} />}
                                renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} impianti={impianti} />}
                                itemsPC={9}
                                itemsMobile={7}
                                needResearch={true}
                                clickableRow={true}
                                archiveClickable={false}
                                actionRow={(row, rowIndex) => {
                                    // Trasforma la data da GG/MM/AAAA a AAAA-MM-GG
                                    let dataInstallazione = row.value.DataInstallazione;
                                    const [gg, mm, aaaa] = dataInstallazione.split("/");
                                    let dataISO = `${aaaa}-${mm}-${gg}`;
                                    setDataRow({ ...row, value: { ...row.value, DataInstallazione: dataISO }, CodiceCliente: Number(idCliente) });
                                    setIsRowInfoVisible(true);
                                }}
                                classes="mt-4"
                                needCheckbox={true}
                                renderButtonForCheckbox={() =>
                                    <Button type="hollow" onClick={handleStampa}>
                                        STAMPA <Printer size={16} strokeWidth={2} className="inline-block ml-1" />
                                    </Button>
                                }
                                needAdd={true}
                                addAction={() => setIsAddVisible(true)}
                                needArchive={true}
                                archiveKey="Obsoleto"
                                archiveValue={true}
                            />
                            <PopUp title={"Aggiungi Articolo"}
                                isVisible={isAddVisible}
                                setIsVisible={setIsAddVisible}
                                needConfirm={true}
                                confirmAction={confirmPopUpAdd}
                                cancelAction={() => { setDataAdd({}); setIsAddVisible(false); setSelectedMacroCat(null); }}
                            >
                                <div className="flex justify-center items-center w-full">
                                    <Button type="hollow" onClick={handleImport} classes="w-[50%]">
                                        IMPORT <Download size={16} strokeWidth={2} className="inline-block ml-1" />
                                    </Button>
                                </div>
                                <div className="flex flex-col items-center">
                                    <Input
                                        label="Codice"
                                        value={dataAdd["Codice"] || ""}
                                        setValue={(value) => setDataAdd({ ...dataAdd, Codice: value })}
                                        type="text"
                                        classes="w-[80%] md:w-[70%] mt-3"
                                        disabled={false}
                                        error={false}
                                    />
                                    <Input
                                        label="Descrizione"
                                        value={dataAdd["Descrizione"] || ""}
                                        setValue={(value) => setDataAdd({ ...dataAdd, Descrizione: value })}
                                        type="text"
                                        classes="w-[80%] md:w-[70%] mt-2"
                                        disabled={false}
                                        error={false}
                                    />
                                    <Combobox
                                        options={impianti.filter(i => i.ID !== 0).map((d) => ({
                                            label: d["Nome"] + (d["Descrizione"] ? ` - ${d["Descrizione"]}` : ""),
                                            value: d["ID"]
                                        }))}
                                        onChange={(value) => setDataAdd({ ...dataAdd, IDImpianto: value })}
                                        label="Sito *"
                                        classes="w-[80%] md:w-[70%] mt-2"
                                        disabled={false}
                                        error={false}
                                        readOnly={false}
                                        defaultValue={dataAdd["IDImpianto"]}
                                    />
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-[80%] md:w-[70%] mt-2">
                                        <Combobox
                                            options={selectMacroCat.map((item) => ({
                                                label: item["Nome"],
                                                value: item["ID"]
                                            }))}
                                            onChange={(value) => { setSelectedMacroCat(value) }}
                                            label="Macro-Categoria"
                                            classes="w-full"
                                            disabled={false}
                                            error={false}
                                            readOnly={false}
                                            defaultValue={selectedMacroCat || selectSottoCat.find(item => item.ID === dataAdd["IDCategoria"])?.IDPadre || null}
                                        />
                                        <Combobox
                                            options={selectSottoCat.filter(item => item["IDPadre"] === (selectedMacroCat || selectSottoCat.find(item => item.ID === dataAdd["IDCategoria"])?.IDPadre || null)).map((item) => ({
                                                label: item["Nome"] + (item["Descrizione"] ? ` - ${item["Descrizione"]}` : ""),
                                                value: item["ID"]
                                            }))}
                                            onChange={(value) => setDataAdd({ ...dataAdd, IDCategoria: value })}
                                            label="Categoria *"
                                            classes="w-full"
                                            disabled={!selectedMacroCat && !selectSottoCat.some(item => item.ID === dataAdd["IDCategoria"])}
                                            error={false}
                                            readOnly={false}
                                            defaultValue={dataAdd["IDCategoria"]}
                                        />
                                    </div>
                                    <DatePicker
                                        label="Data Installazione *"
                                        value={dataAdd["DataInstallazione"] || ""}
                                        setValue={(value) => setDataAdd({ ...dataAdd, DataInstallazione: value })}
                                        error={false}
                                        disabled={false}
                                        classes="w-[80%] md:w-[70%] mt-2"
                                    />
                                    <p className="flex items-center justify-between w-[80%] md:w-[70%] my-4">
                                        QRCode *:
                                        <Button type="icon" onClick={handleQrCode}>
                                            <QrCode size={30} strokeWidth={2} className="inline-block" />
                                        </Button>
                                    </p>
                                </div>
                            </PopUp>
                            <PopUp title={needConfirmRow ? "Modifica Articolo" : ""}
                                isVisible={isRowInfoVisible}
                                setIsVisible={setIsRowInfoVisible}
                                needConfirm={needConfirmRow}
                                confirmAction={confirmPopUpModifica}
                                cancelAction={() => { setNeedConfirmRow(false); setDataRow({}); setIsRowInfoVisible(false); setSelectedMacroCat(null); }}
                            >
                                {needConfirmRow && (
                                    <>
                                        <div className="flex justify-center items-center w-full">
                                            <Button type="hollow" onClick={handleExport}>
                                                EXPORT <Upload size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                        </div>
                                        <div className="flex flex-col items-center">
                                            <Input
                                                label="Codice"
                                                value={dataRow.value["Codice"] || ""}
                                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Codice: value } })}
                                                type="text"
                                                classes="w-[80%] md:w-[70%] mt-2"
                                                disabled={false}
                                                error={false}
                                            />
                                            <Input
                                                label="Descrizione"
                                                value={dataRow.value["Descrizione"] || ""}
                                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, Descrizione: value } })}
                                                type="text"
                                                classes="w-[80%] md:w-[70%] mt-2"
                                                disabled={false}
                                                error={false}
                                            />
                                            <Combobox
                                                options={impianti.filter(i => i.ID !== 0).map((d) => ({
                                                    label: d["Nome"] + (d["Descrizione"] ? ` - ${d["Descrizione"]}` : ""),
                                                    value: d["ID"]
                                                }))}
                                                onChange={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, IDImpianto: value } })}
                                                label="Sito *"
                                                classes="w-[80%] md:w-[70%] mt-2"
                                                disabled={false}
                                                error={false}
                                                readOnly={false}
                                                defaultValue={dataRow.value["IDImpianto"]}
                                            />
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-[80%] md:w-[70%] mt-2">
                                                <Combobox
                                                    options={selectMacroCat.map((item) => ({
                                                        label: item["Nome"],
                                                        value: item["ID"]
                                                    }))}
                                                    onChange={(value) => { setSelectedMacroCat(value) }}
                                                    label="Macro-Categoria"
                                                    classes="w-full"
                                                    disabled={false}
                                                    error={false}
                                                    readOnly={false}
                                                    defaultValue={selectedMacroCat || selectSottoCat.find(item => item.ID === dataRow.value["IDCategoria"])?.IDPadre || null}
                                                />
                                                <Combobox
                                                    options={selectSottoCat.filter(item => item["IDPadre"] === (selectedMacroCat || selectSottoCat.find(item => item.ID === dataRow.value["IDCategoria"])?.IDPadre)).map((item) => ({
                                                        label: item["Nome"] + (item["Descrizione"] ? ` - ${item["Descrizione"]}` : ""),
                                                        value: item["ID"]
                                                    }))}
                                                    onChange={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, IDCategoria: value } })}
                                                    label="Categoria *"
                                                    classes="w-full"
                                                    disabled={!selectedMacroCat && !selectSottoCat.some(item => item.ID === dataRow.value["IDCategoria"])}
                                                    error={false}
                                                    readOnly={false}
                                                    defaultValue={dataRow.value["IDCategoria"]}
                                                />
                                            </div>
                                            <DatePicker
                                                label="Data Installazione *"
                                                value={dataRow.value["DataInstallazione"]}
                                                setValue={(value) => setDataRow({ ...dataRow, value: { ...dataRow.value, DataInstallazione: value } })}
                                                error={false}
                                                disabled={false}
                                                classes="w-[80%] md:w-[70%] mt-2"
                                            />
                                            <Combobox
                                                options={selectAziende.map((item) => ({
                                                    label: item["Nome"],
                                                    value: item["ID"]
                                                }))}
                                                onChange={(value) => setDataRow({ ...dataRow, CodiceCliente: value })}
                                                label="Cliente *"
                                                classes="w-[80%] md:w-[70%] mt-2"
                                                disabled={false}
                                                error={false}
                                                readOnly={false}
                                                defaultValue={Number(dataRow.CodiceCliente)}
                                            />
                                        </div>
                                    </>
                                )}
                                {!needConfirmRow && (
                                    <>
                                        <div className="grid grid-cols-2 mt-2 gap-2">
                                            <Button type="hollow" onClick={handleElimina}>
                                                ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={() => setNeedConfirmRow(true)}>
                                                MODIFICA <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                        </div>
                                        {
                                            isLittle ? (
                                                <>
                                                    <div className="grid grid-cols-2 mt-2 gap-2">
                                                        <Button type="hollow" onClick={() => setIsPopUpFotoVisible(true)}>
                                                            FOTO <Images size={16} strokeWidth={2} className="inline-block ml-1" />
                                                        </Button>
                                                        <Button type="hollow" onClick={() => { setIsReassign(true); setIsQrCodeVisible(true); }}>
                                                            CAMBIA CODICE <RotateCcw size={16} strokeWidth={2} className="inline-block ml-1" />
                                                        </Button>
                                                    </div>
                                                    <PopUp
                                                        title={"Foto"}
                                                        isVisible={isPopUpFotoVisible}
                                                        setIsVisible={setIsPopUpFotoVisible}
                                                        needConfirm={false}
                                                    >
                                                        <div className="flex flex-col items-center">
                                                            <div className="w-[80%]">
                                                                <Input
                                                                    label="Filtra foto..."
                                                                    value={filter}
                                                                    setValue={setFilter}
                                                                    type="text"
                                                                    classes="mb-2 w-full"
                                                                    disabled={false}
                                                                    error={false}
                                                                />
                                                                {
                                                                    viewData.length > 0 ? (
                                                                        viewData.map((elem, index) => (
                                                                            <>
                                                                                <div
                                                                                    className="grid grid-cols-2 p-2 rounded bg-gray-200 dark:bg-neutral-800 hover:bg-gray-300 dark:hover:bg-neutral-700 hover:cursor-pointer my-2"
                                                                                    onClick={() => handleFotoClick(elem["PathFoto"])}
                                                                                >
                                                                                    <span className="self-center font-bold">{elem["PathFoto"].split("/").pop()}</span>
                                                                                    <span className="self-center text-right">{elem["Timestamp"]}</span>
                                                                                    <span className="self-center">{elem["Descrizione"]}</span>
                                                                                    <span className="self-center text-right italic">{`${elem["CognomeUtente"]} ${elem["NomeUtente"]}`}</span>
                                                                                </div>
                                                                                {
                                                                                    isImgVisible && img && (
                                                                                        <div
                                                                                            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back"
                                                                                            onClick={() => setIsImgVisible(false)}
                                                                                        >
                                                                                            <div className="p-4 rounded-lg" style={{ maxWidth: "90vw", maxHeight: "90vh" }}>
                                                                                                <img
                                                                                                    src={img}
                                                                                                    alt="Preview"
                                                                                                    className="max-w-full max-h-[80vh] mx-auto block rounded-md"
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                            </>
                                                                        ))
                                                                    ) : (
                                                                        <p className="text-center">Nessuna foto trovata.</p>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </PopUp>
                                                </>
                                            ) : (
                                                <div className="flex items-center justify-center mt-2">
                                                    <Button type="hollow" classes="w-[70%]" onClick={() => { setIsReassign(true); setIsQrCodeVisible(true); }}>
                                                        CAMBIA CODICE <RotateCcw size={16} strokeWidth={2} className="inline-block ml-1" />
                                                    </Button>
                                                </div>
                                            )
                                        }
                                    </>
                                )}
                            </PopUp>
                            <PopUp title={"QRCode"}
                                isVisible={isQrCodeVisible}
                                setIsVisible={setIsQrCodeVisible}
                                needConfirm={true}
                                confirmAction={confirmPopUpQrCode}
                                cancelAction={() => { setQRCodeContent(null); scanning && handleStopScan(); setIsQrCodeVisible(false); isReassign && setIsReassign(false); }}
                            >
                                <div className="flex flex-col items-center justify-center">
                                    <Button type="hollow" classes="w-[80%] md:w-[60%]" onClick={() => {
                                        setScanning(true);
                                        handleScanCode();
                                    }}>
                                        SCANSIONA QRCODE <ScanLine size={16} strokeWidth={2} className="inline-block ml-2" />
                                    </Button>
                                    <div className='flex justify-center mt-4'>
                                        {
                                            scanning && (
                                                <>
                                                    <video muted autoPlay playsInline hidden id="scan" className="rounded w-[80%] md:w-[60%] h-[80%] md:h-[60%]"></video>
                                                    <canvas
                                                        ref={canvasRef}
                                                        style={{ display: 'none' }}
                                                        hidden
                                                    />
                                                </>
                                            )
                                        }
                                    </div>
                                    <div className="relative flex items-center justify-center w-full my-4">
                                        <div className="absolute w-full h-1 bg-gray-200 dark:bg-neutral-800 rounded"></div>
                                        <span className="relative px-3 bg-gray-100 dark:bg-neutral-900 ">oppure inserisci il codice manualmente</span>
                                    </div>
                                    <Input
                                        label="Codice"
                                        value={qrCodeContent || ""}
                                        setValue={setQRCodeContent}
                                        type="text"
                                        classes="w-[80%] md:w-[60%] mt-2"
                                        disabled={false}
                                        error={false}
                                    />
                                </div>
                            </PopUp>
                        </>
                    )
                }
            </div>
        </div >
    )
};
export default Anagrafica;